import { push } from 'connected-react-router';
import T from 'i18n-react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import LoginActions from '../../reducers/loginRedux';
import OuterContainer from '../Controls/outerContainer';
import './style.css';
import auth from '../../services/auth/AuthProvider';
import HomePageImg from '../../images/HomePageImg.png';
import HomeSection1Icon from '../../images/HomeSection1Icon.svg';
import HomeSection2Icon from '../../images/HomeSection2Icon.svg';   
import HomeSection3Icon from '../../images/HomeSection3Icon.svg';
import { HeapEvents, trackEvent } from '../../utils/AnalyticsUtil'

const HomePage = props => {

    const { requestLogin, lang, loaded } = props    

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const onSignIn = () => {
        trackEvent(HeapEvents.HOMEPAGE_SIGNIN_BTN);
        requestLogin();
    };

    const onContinue = () => {
        trackEvent(HeapEvents.HOMEPAGE_GETSTARTED_BTN);
        auth.signup(lang);
    };

    return (
        <OuterContainer loaded={loaded}>
            <div className='homeTopContainer'>
                <div className='homeTopLeftContainerWrapper'>
                    <div className='homeTopLeftContainer'>
                        <div className='homeTopLeftContainerHeader'>
                            {T.translate('Home.homeTitle')}
                        </div>
                        <div className='homeTopLeftContainerDesc'>
                            {T.translate('Home.homeSubtitle')}
                        </div>
                        <div className='homeTopLeftContainerButtons'>
                            <div className='getStartedButton' onClick={() => onContinue()}>
                                {T.translate('Home.getStarted')}
                            </div>
                            <div className='signInButton' onClick={() => onSignIn()}>
                                {T.translate('Home.signIn')}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='homeTopRightContainer'>
                    <img src={HomePageImg} alt="Home page illustration" />
                </div>
            </div>
            <div className='homeBottomContainer'>
                <div className='homeBottomMainHeader'>
                    {T.translate('Home.homeContentMainHeader')}
                </div>
                <div className='homeBottomSectionsWrapper'>
                    <div className='homeBottomSectionContainer'>
                        <div className='homeBottomSectionTitleWrapper'>
                            <div className='homeSectionIconWrapper'><img className='homeSection1Icon' src={HomeSection1Icon} alt="Section 1 Icon" /></div>
                            <div className='homeBottomSectionTitle'>{T.translate('Home.homeSection1Title')}</div>
                        </div>
                        <div className='homeBottomSectionDesc'>
                            {T.translate('Home.homeSection1Desc')}
                        </div>
                    </div>
                    <div className='homeBottomSectionContainer'>
                        <div className='homeBottomSectionTitleWrapper'>
                            <div className='homeSectionIconWrapper'><img className='homeSection2Icon' src={HomeSection2Icon} alt="Section 2 Icon" /></div>
                            <div className='homeBottomSectionTitle'>{T.translate('Home.homeSection2Title')}</div>
                        </div>
                        <div className='homeBottomSectionDesc'>
                            {T.translate('Home.homeSection2Desc')}
                        </div>  
                    </div>
                    <div className='homeBottomSectionContainer'>
                        <div className='homeBottomSectionTitleWrapper'>
                            <div className='homeSectionIconWrapper'><img className='homeSection3Icon' src={HomeSection3Icon} alt="Section 3 Icon" /></div>
                            <div className='homeBottomSectionTitle'>{T.translate('Home.homeSection3Title')}</div>
                        </div>
                        <div className='homeBottomSectionDesc'>
                            {T.translate('Home.homeSection3Desc')}
                        </div>
                    </div>
                </div>
            </div>
        </OuterContainer>
    );
}

const mapStateToProps = (state) => {
    return {
        layoutType: state.layout.layoutType,
        lang: state.layout.lang || 'en'
    }
}

const mapDispatchToProps = (dispatch) => ({
    pushNavigation: (path) => dispatch(push(path)),
    requestLogin: () => dispatch(LoginActions.requestLogin())
})

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)